import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext} from "react";
import { useTranslation } from "react-i18next";
import { Button} from "reactstrap";
import { translationHookOptions } from "../../../app/localization/localization";
import { RootStoreContext } from "../../../app/stores/rootStore";

const DoubleArrowButton = () => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const { ZwibblerUseDoubleArrowTool, isDoubleArrowEnabled, isZoomed, ZwibblerEnableReadOnlyMode } =
    rootStore.zwibblerStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const handleClick = () => {
    if(isDoubleArrowEnabled)ZwibblerEnableReadOnlyMode();
    else ZwibblerUseDoubleArrowTool();
  };

  return (
    <>
      <Button
        id="doppiaFreccia"
        className={classNames(
          "w-100 px-1 pt-1 pb-1 toolbarButton transparentButton",
          isDoubleArrowEnabled
            ? `${theme!.toolbarActiveIconColor}`
            : `${theme!.toolbarIconColor}`
        )}
        disabled={isZoomed}
        color=""
        onClick={() => handleClick()}
        style={{ position: "relative" }}
      >
        <i className="fas fa-expand-alt iconToolbarButton"></i>

        <h6 className="textToolbarButton mb-0">
          {t("toolbar_double_arrow_button")}
        </h6>
      </Button>
    </>
  );
};

export default observer(DoubleArrowButton);
